<p-toast [style]="{ marginTop: '80px' }"></p-toast>
<p-confirmDialog
  header="Confirmation"
  icon="pi pi-exclamation-triangle"
></p-confirmDialog>

<p-table
  #pt
  [value]="employeeProfiles"
  [lazy]="true"
  (onLazyLoad)="loadLazy($event)"
  dataKey="employeeProfileId"
  selectionMode="single"
  [(selection)]="employeeProfile"
  (onRowSelect)="onRowSelect($event)"
  [loading]="loading"
  [paginator]="showPagination"
  [rows]="25"
  [rowsPerPageOptions]="[25, 100, 200]"
  showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}"
  [totalRecords]="recordTotal"
  sortMode="multiple"
  [multiSortMeta]="multiSortMeta"
  styleClass="p-datatable-striped"
  [ngStyle]="{ width: 'auto' }"
  [resizableColumns]="true"
  [autoLayout]="true"
  [responsive]="true"
  >
  <ng-template pTemplate="caption">
    <div class="d-block text-end justify-content-between align-items-center">
      <h1 style="float: left; margin: 6px">Employee Profiles</h1>
      <span>
        <!--clear filters-->
        @if (showFilter) {
          <button
            pButton
            pRipple
            class="p-button-text"
          style="
            font-size: 80%;
            padding: 0.643rem 0.75rem !important;
            margin-right: 10px;
          "
            (click)="reloadPage()"
            >
            Clear Filters
          </button>
        }

        <!--add new-->
        <button
          pButton
          pRipple
          class="p-button"
          style="padding: 0.643rem 0.75rem !important"
          (click)="onOpenFormAdd()"
          >
          New Employee Profile +
        </button>
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      @for (col of columns; track col) {
        <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
          {{col.header}}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      }
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
    @if (showFilter) {
      <tr>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'firstName', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'lastName', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'emailAddress', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'perEmailAddress', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'mobilePhone', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'perMobilePhone', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'positionName', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'payRate', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'contractOrPerm', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'salaryOrHourly', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"></th>
        <th [ngStyle]="{'width': 'auto'}"></th>
        <th [ngStyle]="{'width': 'auto'}"></th>
        <th [ngStyle]="{'width': 'auto'}"></th>
      </tr>
    }
  </ng-template>
  <ng-template pTemplate="body" let-employeeProfile>
    <tr [pSelectableRow]="employeeProfile">
      <td>{{ employeeProfile.firstName }}</td>
      <td>{{ employeeProfile.lastName }}</td>
      <td>{{ employeeProfile.emailAddress }}</td>
      <td>{{ employeeProfile.perEmailAddress }}</td>
      <td>{{ employeeProfile.mobilePhone }}</td>
      <td>{{ employeeProfile.perMobilePhone }}</td>
      <td>{{ employeeProfile.positionName }}</td>
      <td>{{ employeeProfile.payRate }}</td>
      <td>{{ getContractOrPerms(employeeProfile) }}</td>
      <td>{{ getSalaryOrHourlys(employeeProfile) }}</td>
      <td>{{ employeeProfile.hireDate }}</td>
      <td>{{ employeeProfile.startDate }}</td>
      <td>{{ employeeProfile.termDate }}</td>
      <td>
        <span style="float: none">
          <a>
            <i
              class="pi pi-pencil"
              aria-hidden="true"
              style="color: blue; font-size: 110%; padding-right: 20px"
              (click)="onOpenFormEdit(employeeProfile)"
            ></i>
          </a>
        </span>
      </td>
    </tr>
  </ng-template>
</p-table>
